// @ts-ignore
export const fetcher = (url, init?) => fetch(url, init).catch((r) => console.log("[Fetch Error]: ", r)).then(res => res.json())